import { proxy } from "valtio"
import { deepClone } from "valtio/utils"

// -- Types ---------------------------------------------------------
type ReceiptError = Record<string, string>

type ErrorStateType = {
  insufficientFundsActionError?: boolean
  actionError?: string
  cardError?: string
  receiptErrors?: ReceiptError
  walletError?: string
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: ErrorStateType = {
  insufficientFundsActionError: undefined,
  actionError: undefined,
  cardError: undefined,
  receiptErrors: undefined,
  walletError: undefined,
}

export const ErrorState = proxy<ErrorStateType>(deepClone(INITIAL_STATE))

// -- Actions -------------------------------------------------------
export const ErrorActions = {
  setActionError(error?: string) {
    ErrorState.actionError = error
  },

  setCardError(error: string) {
    ErrorState.cardError = error
  },

  setInsufficientFundsActionError(error: boolean) {
    ErrorState.insufficientFundsActionError = error
  },

  setReceiptErrors(receiptErrors: ReceiptError) {
    const currentErrors = ErrorState.receiptErrors ?? {}
    ErrorState.receiptErrors = { ...currentErrors, ...receiptErrors }
  },

  setWalletError(error: string) {
    ErrorState.walletError = error
  },

  clear() {
    ErrorState.actionError = undefined
    ErrorState.cardError = undefined
    ErrorState.receiptErrors = undefined
    ErrorState.walletError = undefined
  },
}
